import { useTranslation } from 'react-i18next';

function BotReportEditInfo({ report }) {
  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="inputName" className="form-label">
            {t('bots.reports.add.form.name.label')}:
          </label>
          <input type="text" name="name" defaultValue={report.name} className="form-control" id="inputName" required />
        </div>

        <div className="mb-3">
          <label htmlFor="inputDescription" className="form-label">
            {t('bots.reports.add.form.description.label')}:
          </label>
          <textarea name="description" defaultValue={report.description} className="form-control" id="inputDescription"></textarea>
        </div>
      </div>
    </div>
  );
}

export default BotReportEditInfo;
